import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import SignatureCanvas from "react-signature-canvas";
import FormHeader from "../common/FormHeader";
import "./formTitle.css";
import "./themePlaceholder.css";

function TBSUKPN() {
  const navigate = useNavigate();
  const [briefingBy, setBriefingBy] = useState({ name: "", position: "", signature: "", ref: React.createRef() });
  const [briefedTo, setBriefedTo] = useState([
    { name: "", date: "", time: "", signature: "", ref: React.createRef() }
  ]);

  // Briefing given by handlers
  const handleBriefingByChange = (field, value) => {
    setBriefingBy(prev => ({ ...prev, [field]: value }));
  };
  const clearBriefingBySignature = () => {
    if (briefingBy.ref.current) briefingBy.ref.current.clear();
    setBriefingBy(prev => ({ ...prev, signature: "" }));
  };
  const saveBriefingBySignature = () => {
    if (briefingBy.ref.current && !briefingBy.ref.current.isEmpty()) {
      setBriefingBy(prev => ({ ...prev, signature: briefingBy.ref.current.getTrimmedCanvas().toDataURL("image/png") }));
    }
  };

  // Briefed to handlers
  const handleBriefedToChange = (idx, field, value) => {
    setBriefedTo(prev => {
      const updated = [...prev];
      updated[idx][field] = value;
      return updated;
    });
  };
  const clearBriefedToSignature = (idx) => {
    const ref = briefedTo[idx].ref;
    if (ref.current) ref.current.clear();
    setBriefedTo(prev => {
      const updated = [...prev];
      updated[idx].signature = "";
      return updated;
    });
  };
  const saveBriefedToSignature = (idx) => {
    const ref = briefedTo[idx].ref;
    if (ref.current && !ref.current.isEmpty()) {
      setBriefedTo(prev => {
        const updated = [...prev];
        updated[idx].signature = ref.current.getTrimmedCanvas().toDataURL("image/png");
        return updated;
      });
    }
  };
  const addBriefedToBlock = () => {
    setBriefedTo(prev => [...prev, { name: "", date: "", time: "", signature: "", ref: React.createRef() }]);
  };
  const removeBriefedToBlock = () => {
    if (briefedTo.length > 1) {
      setBriefedTo(prev => prev.slice(0, -1));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("TBS UKPN Form submitted!");
    navigate(-1);
  };

  return (
    <div style={{ height: "100vh", overflowY: "auto", background: "#f5f7fa" }}>
      <FormHeader />
      <div className="container py-4">
        
        <div className="card shadow-sm rounded-4 p-4">
          <h2 className="text-center text-white py-2 mb-4 rounded" style={{ backgroundColor: "#8b1634", letterSpacing: "1px", fontSize: "1.8rem" }}>
            UKPN TBS Form
          </h2>
          <form onSubmit={handleSubmit}>
            <div className="row g-4">
              {/* Briefing given by */}
              <div className="col-12">
                <span className="fw-bold" style={{ color: "#8b1634", fontSize: "1.1rem", display: "block", marginBottom: "8px" }}>
                  Briefing given by
                </span>
                <div className="card p-3" style={{ background: "#faf9fa", borderRadius: "18px", border: "1.5px solid #8b1634" }}>
                  <div className="row g-3">
                    <div className="col-md-4">
                      <label className="form-label fw-semibold text-secondary">Name</label>
                      <input
                        type="text"
                        className="form-control mb-3"
                        value={briefingBy.name}
                        onChange={e => handleBriefingByChange("name", e.target.value)}
                        required
                        placeholder="Name"
                        style={{
                          background: "#f7fafd",
                          borderRadius: "10px",
                          border: "2px solid #8b1634",
                          fontSize: "1.08rem"
                        }}
                        onFocus={e => e.target.style.borderColor = "#8b1634"}
                        onBlur={e => e.target.style.borderColor = "#8b1634"}
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label fw-semibold text-secondary">Position</label>
                      <input
                        type="text"
                        className="form-control mb-3"
                        value={briefingBy.position}
                        onChange={e => handleBriefingByChange("position", e.target.value)}
                        required
                        placeholder="Position"
                        style={{
                          background: "#f7fafd",
                          borderRadius: "10px",
                          border: "2px solid #8b1634",
                          fontSize: "1.08rem"
                        }}
                        onFocus={e => e.target.style.borderColor = "#8b1634"}
                        onBlur={e => e.target.style.borderColor = "#8b1634"}
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label fw-semibold text-secondary">Signature</label>
                      <div style={{
                        width: '100%',
                        border: '2px solid #8b1634',
                        borderRadius: '18px',
                        background: '#e9cfd6',
                        padding: '0.5rem',
                        textAlign: 'left',
                        position: 'relative',
                        minHeight: '120px',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center'
                      }}>
                        <SignatureCanvas
                          ref={briefingBy.ref}
                          penColor="#8b1634"
                          backgroundColor="#e9cfd6"
                          clearOnResize={false}
                          velocityFilterWeight={0.7}
                          minWidth={1}
                          maxWidth={2.5}
                          dotSize={1.5}
                          throttle={16}
                          canvasProps={{
                            width: window.innerWidth > 600 ? 350 : 300,
                            height: 100,
                            style: {
                              width: '100%',
                              height: '100px',
                              border: 'none',
                              borderRadius: '18px',
                              background: '#e9cfd6',
                              display: 'block',
                              touchAction: 'none'
                            }
                          }}
                          onEnd={saveBriefingBySignature}
                        />
                        <div style={{
                          width: '100%',
                          display: 'flex',
                          justifyContent: 'flex-end',
                          marginTop: '4px'
                        }}>
                          <button
                            type="button"
                            className="btn btn-outline-danger btn-sm rounded-pill px-3"
                            style={{
                              background: 'transparent',
                              color: '#8b1634',
                              borderColor: '#8b1634'
                            }}
                            onClick={clearBriefingBySignature}>
                            Clear
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Briefed to */}
              <div className="col-12 mt-4">
                <span className="fw-bold" style={{ color: "#8b1634", fontSize: "1.1rem", display: "block", marginBottom: "4px" }}>
                  Briefed to:
                </span>
                <span style={{ color: "#6c757d", fontSize: "0.98rem", marginBottom: "8px", display: "block" }}>
                  (by signing below I confirm that I have received and understood the briefing for this task)
                </span>
                {briefedTo.map((sig, idx) => (
                  <div className="card p-3 mb-3" style={{ background: "#faf9fa", borderRadius: "18px", border: "1.5px solid #8b1634" }} key={idx}>
                    <div className="row g-3">
                      <div className="col-12">
                        <div className="row g-3">
                          <div className="col-md-4">
                            <label className="form-label fw-semibold text-secondary">Name</label>
                            <input
                              type="text"
                              className="form-control mb-3"
                              value={sig.name}
                              onChange={e => handleBriefedToChange(idx, "name", e.target.value)}
                              required
                              placeholder="Name"
                              style={{
                                background: "#f7fafd",
                                borderRadius: "10px",
                                border: "2px solid #8b1634",
                                fontSize: "1.08rem"
                              }}
                              onFocus={e => e.target.style.borderColor = "#8b1634"}
                              onBlur={e => e.target.style.borderColor = "#8b1634"}
                            />
                          </div>
                          <div className="col-md-4">
                            <label className="form-label fw-semibold text-secondary">Date</label>
                            <input
                              type="date"
                              className="form-control mb-3"
                              value={sig.date}
                              onChange={e => handleBriefedToChange(idx, "date", e.target.value)}
                              required
                              placeholder="Date"
                              style={{
                                background: "#f7fafd",
                                borderRadius: "10px",
                                border: "2px solid #8b1634",
                                fontSize: "1.08rem"
                              }}
                              onFocus={e => e.target.style.borderColor = "#8b1634"}
                              onBlur={e => e.target.style.borderColor = "#8b1634"}
                            />
                          </div>
                          <div className="col-md-4">
                            <label className="form-label fw-semibold text-secondary">Time</label>
                            <input
                              type="time"
                              className="form-control mb-3"
                              value={sig.time}
                              onChange={e => handleBriefedToChange(idx, "time", e.target.value)}
                              required
                              placeholder="Time"
                              style={{
                                background: "#f7fafd",
                                borderRadius: "10px",
                                border: "2px solid #8b1634",
                                fontSize: "1.08rem"
                              }}
                              onFocus={e => e.target.style.borderColor = "#8b1634"}
                              onBlur={e => e.target.style.borderColor = "#8b1634"}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-4">
                        <label className="form-label fw-semibold text-secondary">Signature</label>
                        <div style={{
                          width: '100%',
                          border: '2px solid #8b1634',
                          borderRadius: '18px',
                          background: '#e9cfd6',
                          padding: '0.5rem',
                          textAlign: 'left',
                          position: 'relative',
                          minHeight: '120px',
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'center'
                        }}>
                          <SignatureCanvas
                            ref={sig.ref}
                            penColor="#8b1634"
                            backgroundColor="#e9cfd6"
                            clearOnResize={false}
                            velocityFilterWeight={0.7}
                            minWidth={1}
                            maxWidth={2.5}
                            dotSize={1.5}
                            throttle={16}
                            canvasProps={{
                              width: window.innerWidth > 600 ? 350 : 300,
                              height: 100,
                              style: {
                                width: '100%',
                                height: '100px',
                                border: 'none',
                                borderRadius: '18px',
                                background: '#e9cfd6',
                                display: 'block',
                                touchAction: 'none'
                              }
                            }}
                            onEnd={() => saveBriefedToSignature(idx)}
                          />
                          <div style={{
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'flex-end',
                            marginTop: '4px'
                          }}>
                            <button
                              type="button"
                              className="btn btn-outline-danger btn-sm rounded-pill px-3"
                              style={{
                                background: 'transparent',
                                color: '#8b1634',
                                borderColor: '#8b1634'
                              }}
                              onClick={() => clearBriefedToSignature(idx)}>
                              Clear
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
                {/* Add/Remove buttons for signature section - Attractive UI */}
                <div className="d-flex justify-content-end gap-3 mt-3">
                  <button
                    type="button"
                    className="btn btn-circle"
                    style={{
                      fontSize: '1.3rem',
                      width: '36px',
                      height: '36px',
                      borderRadius: '50%',
                      background: briefedTo.length === 1 ? '#eaeaea' : '#8b1634',
                      color: briefedTo.length === 1 ? '#aaa' : '#fff',
                      border: 'none',
                      boxShadow: '0 2px 8px rgba(139,22,52,0.10)',
                      transition: 'background 0.2s, color 0.2s',
                      cursor: briefedTo.length === 1 ? 'not-allowed' : 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                    onClick={removeBriefedToBlock}
                    disabled={briefedTo.length === 1}
                    title="Remove signature section"
                  >
                    <i className="fa fa-minus" aria-hidden="true"></i>
                  </button>
                  <button
                    type="button"
                    className="btn btn-circle"
                    style={{
                      fontSize: '1.3rem',
                      width: '36px',
                      height: '36px',
                      borderRadius: '50%',
                      background: '#8b1634',
                      color: '#fff',
                      border: 'none',
                      boxShadow: '0 2px 8px rgba(139,22,52,0.10)',
                      transition: 'background 0.2s, color 0.2s',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                    onClick={addBriefedToBlock}
                    title="Add signature section"
                  >
                    <i className="fa fa-plus" aria-hidden="true"></i>
                  </button>
                </div>
              </div>

              {/* Submit Button */}
              <div className="col-12 text-center mt-4">
                <button type="submit" className="btn btn-lg text-white fw-bold px-5 py-2"
                  style={{
                    backgroundColor: "#8b1634",
                    borderRadius: "30px",
                    boxShadow: "0 4px 12px rgba(139,22,52,0.3)"
                  }}>
                  Submit
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
export default TBSUKPN;
